export enum AccountAttributionTabs {
  Opportunities = 'opportunities',
  People = 'people',
  OrphanLeads = 'orphanLeads',
  CampaignResponses = 'campaignResponses',
  SalesActivities = 'salesActivities',
  Advertising = 'advertising'
}
